export const pageRedirect = (element, redirectUrl) => {
  element.attr("data-target") === "_blank"
    ? window.open(redirectUrl)
    : (window.location.href = redirectUrl);
};
